<template>
  <div>
    <span>{{label}}</span>
    <br>
    <el-select @change="updateList" @input="updateList" v-model="search" :placeholder="placeholder">
      <el-option label="-" value></el-option>
      <el-option v-for="(option, index) in options" :key="index" :label="$t(option[optionLabel])" :value="option.id"></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "Filters",
  props: {
    label: {
      type: String
    },
    tableData: {
      type: Array
    },
    options: {
      type: Array
    },
    optionLabel: {
      type: String,
      default: "name"
    },
    optionValue: {
      type: String
    },
    placeholder: {
      type: String,
      default: "Filter"
    }
  },
  data() {
    return {
      search: undefined,
      unfilteredList: undefined
    };
  },
  computed: {
    filteredList() {
      if (!this.search) {
        return this.unfilteredList;
      } else {
        let key = this.optionValue;
        let options = this.options;
        let matcher = new RegExp(this.search, "i");
        return this.unfilteredList.filter(function(data) {
          if (matcher.test(data[key])) {
            return matcher.test(data[key]);
          }
        });
      }
    }
  },
  async created() {
    this.unfilteredList = await this.tableData;
  },
  watch: {
    tableData() {
      this.unfilteredList = this.tableData;
    }
  },
  methods: {
    updateList() {
      this.$emit("filtered-list", this.filteredList);
    }
  }
};
</script>

<style scoped>
.el-input__inner {
  border: 1px solid white !important;
  border-radius: 4px;
}
.search {
  width: 25%;
  border: none;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
  border-width: 1px;
  border-color: var(--white);
  /* border-radius:  */
}

/* .search:active {
        box-shadow: 0 2px 4px 0 #409EFF;
    } */
</style>



// WEBPACK FOOTER //
// src/components/Filters/FilterByOptions.vue